<template>
<div>

    <b-loading :is-full-page="true" :active.sync="isLoading" :can-cancel="false" />

    <!-- CALLING || INCALL -->
    <div v-if="state === 'calling' || state === 'incall'">
        <p class="header-remote-name">{{ sessionData.user }}</p>
        <h1 v-if="state=== 'calling'" class="title calling">{{ texts.calling }}</h1>
        <h1 v-if="state=== 'incall'" class="title calling">{{ texts.connected }}</h1>
        <button
            class="button calling-btn is-dark"
            :class="{
                'calling-btn-shake': state === 'calling'
            }"
            disabled
        >
            <b-icon
                pack="fas"
                :icon="state === 'calling' ? 'phone' : 'volume-up'"
                custom-class="calling-icon"
            />
        </button>
        <div class="actions actions-center">
            <button
                class="button is-danger actions-btn"
                @click="hangup()"
            >
                <b-icon
                    pack="fas"
                    icon="times">
                </b-icon>
            </button>
        </div>
    </div>

    <div v-show="state == 'incall'" id="localvideo"></div>
    <div v-show="state == 'incall'" id="remotevideo"></div>
    <div v-show="state == 'incall'" id="remotescreen"></div>
    <div v-show="state == 'incall'" id="localscreen"></div>

</div>
</template>

<script>
import { Utils } from '../../mixins/Utils';
import HealthCareService from '../../services/HealthCareService';

export default {
    name: 'SipCall',
    mixins: [ Utils ],
    data () {
        return {
            serverConfig: {},
            config: {},
            texts: {},
            state: '',
            session: null,
            sessionData: null,
            videortc: {
                app: null,
                ucases: null,
                actions: null,
            },
            isLoading: true,
        }
    },
    mounted() {
        this.config = JSON.parse(JSON.stringify(this.$parent.config));
        this.texts = JSON.parse(JSON.stringify(this.$parent.texts));
        if (!HealthCareService.isLogged()) this.$router.push('/');
        this.session = this.$route.params.session;
        this.loadServerConfig();
        HealthCareService.getSession(this.session)
            .then(res => {
                this.sessionData = res.data;
                if (this.sessionData.notificationMethod === 'sms') {
                    this.connect(this.sessionData.notificationParam);
                }
                else {
                    this.setLoading(false);
                    this.$buefy.dialog.prompt({
                        message: this.texts.enterPhone,
                        inputAttrs: {},
                        trapFocus: true,
                        confirmText: this.texts.accept,
                        cancelText: this.texts.close,
                        onConfirm: value => {
                            if (this.serverConfig['phone-regexp']) {
                                const reg = new RegExp(this.serverConfig['phone-regexp']);
                                if (!reg.test(value)) {
                                    this.$buefy.toast.open({ message: this.texts.invalidPhone, type: 'is-danger', position: 'is-bottom' });
                                    setTimeout(() => {
                                        window.VideoRTC.unique_ids = undefined;
                                        window.location.pathname = '/professional/call';
                                    }, 300);
                                    return false;
                                }
                            }
                            this.connect(value);
                        },
                        onCancel: () => {
                            window.VideoRTC.unique_ids = undefined;
                            window.location.pathname = '/professional/call';
                        }
                    })
                }
            })
            .catch(error => {
                const err = (error.response && error.response.data && error.response.data.error) ? error.response.data.error : 'Error';
                this.$buefy.toast.open({ message: err, type: 'is-danger', position: 'is-bottom' });
                setTimeout(() => {
                    this.disconnect();
                }, 1000);
            })

    },
    methods: {
        loadServerConfig() {
            HealthCareService.getConfig()
                .then(res => {
                    this.serverConfig = res.data;
                })
                .catch(error => {
                    const err = (error.response && error.response.data && error.response.data.error) ? error.response.data.error : 'Error';
                    this.$buefy.toast.open({ message: err, type: 'is-danger', position: 'is-bottom' });
                })
        },
        setLoading(isLoading) {
            this.isLoading = isLoading;
        },
        connect(phone) {
            this.videortc.app = new VideoRTC(server, iceServers, debugLevel, apiSecret);
            this.videortc.app.connect()
                .then(usecases => {
                    this.ucases = usecases;
                    this.startSplitClient(phone);
                })
                .catch(cause => {
                    this.setLoading(false);
                    this.$buefy.toast.open({ message: cause || 'Error connecting with the VideoRTC', type: 'is-danger', position: 'is-bottom' });
                });
        },
        startSplitClient(phone) {
            const onEvents = {
                onCalling: () => {
                    this.state = 'calling';
                },
                onRegisteredFailed: cause => {
                    this.$buefy.toast.open({ message: this.texts.connectingError, type: 'is-danger', position: 'is-bottom' });
                    this.disconnect();
                },
                onHangup: (code, cause) => {
                    if (code && code !== 200) {
                        this.$buefy.toast.open({ message: cause, type: 'is-danger', position: 'is-bottom' });
                        this.disconnect();
                        return;
                    }
                    // 200 Hangup
                    this.disconnect();
                },
                onAcceptedAudio: (data, stream) => {
                    //this.vueInsomnia().on();
                    this.state = 'incall';
                    HealthCareService.increaseCallCount();
                },
                onReadyLocalAudio: () => {},
                onJoined: () => {},
                onSipMessage: (sender, content) => {},
            };
            const domElements = {
                local: document.getElementById('localvideo'),
                remote: document.getElementById('remotevideo'),
                screenRemote: document.getElementById('remotescreen'),
                screenLocal: document.getElementById('localscreen')
            };
            const options = {
                stream: {
                    audioEnabled: true,
                    videoEnabled: false
                },
            };
            if (this.config.account) options.account = this.config.account;
            this.ucases.splitClient(onEvents, domElements, options)
                .then(acts => {
                    this.videortc.actions = acts;
                    this.setLoading(false);
                    this.call(phone);
                })
                .catch(cause => {
                    this.setLoading(false);
                    this.$buefy.toast.open({ message: cause || 'Error', type: 'is-danger', position: 'is-bottom' });
                });
        },
        disconnect() {
            this.vueInsomnia().off();
            this.videortc.app.disconnect();
            window.VideoRTC.unique_ids = undefined;
            window.location.pathname = '/professional/call';
        },
        call(phone) {
            if (!phone) {
                this.$buefy.toast.open({ message: this.texts.invalidPhone || 'Error', type: 'is-danger', position: 'is-bottom' });
                this.disconnect();
            }
            this.videortc.actions.call(this.config.sipCallerId, 128000, 128000, { 'X-Phone': phone }, 'sip:videortc@127.0.0.1:5099');
        },
        hangup() {
            this.$buefy.dialog.confirm({
                message: this.texts.endCall,
                cancelText: this.texts.no,
                confirmText: this.texts.yes,
                type: 'is-success',
                onConfirm: () => {
                    this.videortc.actions.hangup();
                    //this.disconnect();
                },
            });
        },
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.header-remote-name {
    position: fixed;
    z-index: 2;
    top: 65px;
    left: 50%;
    transform: translate(-50%);
    background: rgba(250,250,250,0.5);
    padding: 3px 5px;
    border-radius: 3px;
}
.calling {
    margin-top: 20vh;
    @media (max-height: 450px) {
        margin-top: 10px;
        margin-bottom: 0px;
    }
}
.actions {
    position: absolute;
    bottom: 20px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 0px 20px;
    .actions-btn {
        border-radius: 30px;
        height: 60px;
        width: 60px;
    }
}
.actions-center {
    justify-content: center;
    z-index: 2;
}
.calling-btn {
    top: 22px;
    z-index: 3;
    height: 140px;
    width: 140px;
    border-radius: 70px;
    font-size: 2.2em;
    transform: translate3d(0, 0, 0);
    backface-visibility: hidden;
    perspective: 1000px;
    @media (max-height: 450px) {
        height: 100px;
        width: 100px;
        top: 55px;
    }
}
.calling-btn-shake {
    animation: shake 0.82s cubic-bezier(.36,.07,.19,.97) infinite;
}
@keyframes shake {
    10%, 90% {
        transform: translate3d(-1px, 0, 0);
    }
    20%, 80% {
        transform: translate3d(2px, 0, 0);
    }
    30%, 50%, 70% {
        transform: translate3d(-4px, 0, 0);
    }
    40%, 60% {
        transform: translate3d(4px, 0, 0);
    }
}
</style>



// WEBPACK FOOTER //
// src/components/professional/SipCall.vue